/*
 * Casual deterrents against copying site photography: blocks the right-click /
 * long-press "save image" menu and image drag-out, and shows a brief warning
 * only when someone actually tries — never a standing banner. This cannot stop
 * a determined visitor (screenshots, dev tools), only casual copying.
 */
(function () {
  'use strict';

  var isHebrew = document.documentElement.getAttribute('dir') === 'rtl' ||
    (document.documentElement.getAttribute('lang') || '').indexOf('he') === 0;

  var MESSAGE = isHebrew
    ? 'התמונות באתר זה מוגנות בזכויות יוצרים ואין להעתיקן ללא רשות.'
    : 'Images on this site are copyright protected and may not be copied without permission.';

  var toast = null;
  var hideTimer = null;

  function showWarning() {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'damder-copy-warning';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.textContent = MESSAGE;
      document.body.appendChild(toast);
    }
    toast.classList.add('damder-copy-warning--visible');
    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(function () {
      toast.classList.remove('damder-copy-warning--visible');
    }, 2600);
  }

  function isProtectedImage(target) {
    var img = target && target.closest ? target.closest('img') : null;
    if (!img) return false;
    // Leave third-party credit/partner logos (e.g. the EYC footer mark) alone.
    return !img.closest('.damder-footer-credit__eyc-brand');
  }

  document.addEventListener('contextmenu', function (e) {
    if (isProtectedImage(e.target)) {
      e.preventDefault();
      showWarning();
    }
  });

  document.addEventListener('dragstart', function (e) {
    if (isProtectedImage(e.target)) {
      e.preventDefault();
      showWarning();
    }
  });
})();
